/**
 * Lazy loader for languages.
 *
 * @see https://www.i18next.com/misc/creating-own-plugins
 */
export class LazyLoader {
    public static type = 'backend';

    public readMulti() {
        throw new Error('not supported');
    }

    public read(language: string, namespace: string, callback: (error: any, data?: any) => void) {
        import(`./languages/${language}/${namespace}`)
            .then((data) => callback(null, data))
            .catch((error) => callback(error, null));
    }
}



// WEBPACK FOOTER //
// ./src/i18n/LazyLoader.ts